import React, { useState } from "react";
import Modal from "shared/components/UIElements/Modal";

import Button from "shared/components/FormElements/Button";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import InfoIcon from "@mui/icons-material/Info";
import "./Help.css";

const Help = ({ standardHelpItems, highlightedHelpItems }) => {
  const [showHelpModal, setShowHelpModal] = useState(false);

  return (
    <React.Fragment>
      <Modal
        show={showHelpModal}
        onCancel={() => setShowHelpModal(false)}
        header="Yardım"
        footerClass="shared-help-footer"
        footer={
          <React.Fragment>
            <Button inverse onClick={() => setShowHelpModal(false)}>
              Kapat
            </Button>
          </React.Fragment>
        }
      >
        <div className="shared-help-content">
          {standardHelpItems && (
            <div>
              <h4
                style={{
                  marginTop: "0",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  columnGap: "0.5rem",
                }}
              >
                <InfoIcon color="info" />
                Bu sayfada yapabileceğiniz işlemler
              </h4>
              {standardHelpItems.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
            </div>
          )}
          {highlightedHelpItems && (
            <div>
              <h4
                style={{
                  marginTop: "2rem",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  columnGap: "0.5rem",
                }}
              >
                <WarningAmberOutlinedIcon color="warning" /> Dikkat edilmesi gereken noktalar
              </h4>
              {highlightedHelpItems.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
            </div>
          )}
        </div>
      </Modal>
      <Button danger size="small" onClick={() => setShowHelpModal(true)}>
        Yardım
      </Button>
    </React.Fragment>
  );
};

export default Help;
